import React from 'react';
import VersionNum from '../Common/VersionNum';

import './PageHeader.scss';


class PageHeader extends React.Component {
  render() {
    const {
      heading = null,
      subheading = null,
      actions = [],
      actions2 = [],
    } = this.props;

    return (
      <div className="parkchirp--page-header">
        {(heading !== null || subheading !== null) &&
          <div className="parkchirp--page-heading-container">
            {(heading !== null) && (typeof heading !== `object`) &&
              <h1 className="parkchirp--page-heading">
                {heading}
              </h1>
            }
            {(heading !== null) && (typeof heading === "object") &&
              <div className="parkchirp--page-heading-group">
                {heading.map((headingItem, index) =>
                  <h1 key={index} className="parkchirp--page-heading">
                    {headingItem}
                  </h1>
                )}
              </div>
            }
            {(subheading !== null) && (typeof subheading !== "object") &&
              <p className="parkchirp--page-subheading">
                {subheading}
              </p>
            }
            {(subheading !== null) && (typeof subheading === "object") &&
              <div className="parkchirp--page-subheading-group">
                {subheading.map((subheadingItem, index) =>
                  <h1 key={index} className="parkchirp--page-subheading">
                    {subheadingItem}
                  </h1>
                )}
              </div>
            }
            <VersionNum className="parkchirp--page-heading--aside" />
          </div>
        }
        { (actions.length || actions2.length) &&
          <div className="parkchirp--page-actions-container parkchirp--page-actions-container--right">
            {(actions.length > 0) &&
              <ul className="parkchirp--page-actions">
                {actions.map((action, index) =>
                  <li key={index}
                    className="parkchirp--page-action">
                    {action}
                  </li>
                )}
              </ul>
            }
            {(actions2.length > 0) &&
              <ul className="parkchirp--page-actions">
                {actions2.map((action, index) =>
                  <li key={index}
                      className="parkchirp--page-action">
                    {action}
                  </li>
                )}
              </ul>
            }
          </div>
        }
      </div>
    );
  }
}
export default PageHeader;
